import { isRouteErrorResponse, useRouteError } from "react-router";

export function RouteErrorView() {
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : 500;

  return (
    <main className="error-view">
      <h1>Route unavailable</h1>
      <p>Request failed with status {status}.</p>
    </main>
  );
}
